if (!customElements.get('theme-sticky-header')) {
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.mode = this.dataset.mode;
      this.header = this.querySelector('.header');

      if (!this.header || this.mode === 'none') {
        this._publishHeight();
        return;
      }

      this._abortController = new AbortController();
      const signal = this._abortController.signal;

      this._publishHeight();
      this._publishStickyTop();
      this._rafId = null;
      this.lastScrollY = window.scrollY;
      this.scrolledThreshold = 0;
      this._directionAnchor = window.scrollY;
      this._currentDirection = null;

      window.addEventListener('scroll', () => {
        if (this._rafId) return;
        this._rafId = requestAnimationFrame(() => {
          this._handleScroll();
          this._rafId = null;
        });
      }, { passive: true, signal });

      window.addEventListener('resize', theme.utils.debounce(() => {
        this._publishHeight();
        this._publishStickyTop();
      }, 100), { signal });
    }

    disconnectedCallback() {
      this._abortController?.abort();
      if (this._rafId) cancelAnimationFrame(this._rafId);
    }

    _publishHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    _publishStickyTop() {
      const barHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height')) || 0;
      const barIsSticky = !!document.querySelector('.announcement-bar--sticky');
      const top = barIsSticky ? barHeight : Math.max(0, barHeight - window.scrollY);
      document.documentElement.style.setProperty('--header-sticky-top', `${top}px`);
    }

    _handleScroll() {
      const currentScrollY = window.scrollY;
      const delta = currentScrollY - this.lastScrollY;
      this.lastScrollY = currentScrollY;

      this._publishStickyTop();

      if (currentScrollY > this.scrolledThreshold) {
        this.header.classList.add('header--scrolled');
      } else {
        this.header.classList.remove('header--scrolled');
      }

      if (this.mode !== 'hide_on_scroll_down') return;

      const rawDirection = delta > 0 ? 'down' : delta < 0 ? 'up' : null;
      if (!rawDirection) return;

      if (rawDirection !== this._currentDirection) {
        this._directionAnchor = currentScrollY;
        this._currentDirection = rawDirection;
      }

      const accumulated = Math.abs(currentScrollY - this._directionAnchor);
      if (accumulated < 10) return;

      const atBottom = currentScrollY + window.innerHeight >= document.documentElement.scrollHeight - 8;

      if (this._currentDirection === 'down' && currentScrollY > this.offsetHeight) {
        this.header.classList.add('header--hidden');
      } else if (this._currentDirection === 'up' && !atBottom) {
        this.header.classList.remove('header--hidden');
      }
    }
  }

  customElements.define('theme-sticky-header', StickyHeader);
}
